( function( $ ) {
  /* Make the title height adjustable */
  if( $( this ).width() >= 1024 ) {
    var heights = $( '.__3_column_pricing .__price' ).map( function( i, el ) {
      return $( '.__price--header', el ).outerHeight();
    } ).get();

    $( '.__3_column_pricing .__price' ).css( 'padding-top', Math.max.apply( Math, heights ) + 'px' );
    $( '.__3_column_pricing .__price .__price--header' ).height( Math.max.apply( Math, heights ) - 40 );
  } else {
    $( '.__3_column_pricing .__price' ).css( 'padding-top', '0' );
    $( '.__3_column_pricing .__price .__price--header' ).height( 'auto' );
  }

  $( window ).resize( function () {
    if( $( window ).width() >= 1007 ) {
      heights = $( '.__3_column_pricing .__price' ).map( function( i, el ) {
        return $( '.__price--header', el ).outerHeight();
      } ).get();

      $( '.__3_column_pricing .__price' ).css( 'padding-top', Math.max.apply( Math, heights ) + 'px' );
      $( '.__3_column_pricing .__price .__price--header' ).height( Math.max.apply( Math, heights ) - 40 );
    } else {
      $( '.__3_column_pricing .__price' ).css( 'padding-top', '0' );
      $( '.__3_column_pricing .__price .__price--header' ).height( 'auto' );
    }
  } );
} ) ( jQuery );